import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '疫战成铭——抗疫期间最值得铭记的APP评选';

const route: RouteConfig = {
  path: '/20200402YZCM',
  name: '20200402YZCM',
  component: () => import('./home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: '20200402YZCM/List',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'News',
      component: () => import('./News.vue'),
      name: '20200402YZCM/News',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      component: () => import('./rules.vue'),
      name: '20200402YZCM/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
